import React from 'react';
import { Route } from 'react-router-dom';

import DashboardLayout from '../components/dashboard/DashboardLayout';
import SettingsNavigation from './SettingsNavigation';
import AuthenticatedRoutes from './AuthenticatedRoutes';
import Subscription from '../components/subscription/Subscription';
import SupportNavigation from './SupportNavigation';
import VendorLoginLayout from '../components/vendor-login/VendorLoginLayout';
import VendorNavigation from './VendorNavigation';
import Payment from '../components/subscription/Payment';
import SupportNavbar from '../common/layout/SupportNavbar';
import ThankYou from '../components/subscription/ThankYou';

const listOfNavigation = [
  {
    path: '/settings/*',
    element: (
      <DashboardLayout>
        <SettingsNavigation />
      </DashboardLayout>
    ),
    key: 'settings'
  },
  {
    path: '/subscription',
    element: <Subscription />,
    key: 'subscription'
  },
  {
    path: '/thank-you',
    element: <ThankYou />,
    key: 'subscription'
  },
  {
    path: '/pay',
    element: <Payment />,
    key: 'Pay'
  },
  {
    path: '/support/*',
    element: (
      <SupportNavbar>
        <SupportNavigation />
      </SupportNavbar>
    ),
    key: 'support-routes'
  },
  {
    path: '/vendor-login/*',
    element: (
      <VendorLoginLayout>
        <VendorNavigation />
      </VendorLoginLayout>
    ),
    key: 'Vendor-login'
  }
];

export default [
  <Route element={<AuthenticatedRoutes />} key="authenticated-routes">
    {listOfNavigation.map((route) => (
      <Route key={route.key} path={route.path} element={route.element} />
    ))}
  </Route>
];
